import React from 'react';
import { ReactComponent as Logo } from 'images/Logo.svg';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core';

export const Header: React.FC = () => {
  const classes = useStyles();

  return (
    <header className={classes.staticHeader}>
      <div className={classes.container}>
        <div className={classes.logoContainer}>
          <Logo data-testid="logo" className={classes.logo} />
        </div>
      </div>
    </header>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    staticHeader: {
      height: '75px',
      border: '1px solid var(--outline-on-surface-000000-12-)',
      backgroundColor: '#002e41',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
    },
    container: {
      maxWidth: '1440px',
      margin: '0 auto',
      height: '65px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 20px',
      color: '#fff'
    },
    logoContainer: {
      width: '135px'
    },
    logo: {
      width: '100%'
    }
  })
);
